import { component } from "picoapp";
import { malomoTracking } from "../../utilities/fetchMalomoTrackingURL";

export const malomoForm = component((node) => {
  async function handleSubmit(
    event: SubmitEvent & { target: HTMLFormElement }
  ) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const baseUrl = new URL("https://api.gomalomo.com/orders");
    const form = event.target;
    const formErrorWrapper = form?.querySelector<HTMLElement>(".js-form-error");
    const formError =
      formErrorWrapper?.querySelector<HTMLParagraphElement>(
        ".js-form-error > p"
      );

    for (const [name, value] of formData.entries()) {
      if (!value) {
        formErrorWrapper?.classList.remove("tw-hidden");
        formError.innerHTML = "Please fill in the fields";
        return;
      }
      if (typeof value === "string") {
        if (
          (name === "number" && value.includes("#")) ||
          (name === "tracking_code" && value.includes("#"))
        ) {
          baseUrl.searchParams.append(name, value.replace("#", ""));
        } else {
          baseUrl.searchParams.append(name, value);
        }
      }
    }
    try {
      const data = await malomoTracking(baseUrl);

      if (data.url) {
        window.location.href = data.url;
      } else {
        formErrorWrapper?.classList.remove("tw-hidden");
        formError.innerHTML =
          "There was an error in the form. Please try submitting again";
      }
    } catch (e) {
      console.error(e);
    }
  }

  const forms = node.querySelectorAll("form");
  forms.forEach((form) => form.addEventListener("submit", handleSubmit));
});
